import { render, staticRenderFns } from "./DistributorDetail.vue?vue&type=template&id=2b062ef5&"
import script from "./DistributorDetail.vue?vue&type=script&lang=js&"
export * from "./DistributorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports